export default __webpack_public_path__ + "static/media/abir.5e192803.jpg";